<template>
  <li>
    <router-link :to="{ name: 'impersonate' }" v-if="canImpersonate && !isImpersonating">
      Impersonate
    </router-link>
  </li>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'ImpersonateLink',
  computed: {
    ...mapGetters('impersonate', [
      'isImpersonating',
    ]),
    ...mapGetters('auth', [
      'hasPerm',
    ]),
    canImpersonate() {
      return this.hasPerm('dashboard.impersonate')
    }
  },
  methods: {}
}
</script>